import request from './base/api';

export function fetchScheduleTime({ id, date }, cb, errCb) {
  const config = {
    params: {
      date
    }
  };

  return request({
    url: 'schedule-times/' + id,
    method: 'get',
    cb,
    errCb,
    config
  });
}

export default {
  fetchScheduleTime
};
